<template>
  <div v-if="vuexModalOpened" @click="close" class="overlay"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vuexModalOpened: 'common/openedModal'
    })
  },
  methods: {
    close() {
      this.$emit('close')
      this.$store.commit('common/TOGGLE_MODAL', false)
    }
  }
}
</script>

<style lang="scss">
.overlay {
  position: fixed;
  z-index: 900;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: hsla(0, 0%, 77.17%, 0.85);
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseOverlay.vue